import { action } from 'typesafe-actions';

// Types
import { AudioTypes } from './types';

// Get Audio
export const getAudioRequest = (payload: object) =>
  action(AudioTypes.GET_AUDIO_REQUEST, payload);

export const getAudioSuccess = (payload: { audioLink: string }) =>
  action(AudioTypes.GET_AUDIO_SUCCESS, payload);

export const getAudioFailure = () => action(AudioTypes.GET_AUDIO_FAILURE);

// Create Audio
export const createAudioRequest = (payload: { name?: string | null }) =>
  action(AudioTypes.CREATE_AUDIO_REQUEST, payload);

export const createAudioSuccess = (payload: { createdAudioLink: string }) =>
  action(AudioTypes.CREATE_AUDIO_SUCCESS, payload);

export const createAudioFailure = () => action(AudioTypes.CREATE_AUDIO_FAILURE);
